export default __webpack_public_path__ + "static/media/gallery12.b3d5bff4.jpg";